import React from 'react';
import { Routes, Route } from "react-router-dom";
import Header from "./components/header";
import Home from "./pages/Home";
import TarotReading from "./pages/TarotReading";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { LanguageProvider } from './data/LanguageContext';

function App() {

  return (
    <LanguageProvider>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reading" element={<TarotReading />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </LanguageProvider>
  );
}

export default App;
